const HTTPStatus = {
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  OK: 200
};

export default HTTPStatus;
